import { useMutation } from "@apollo/react-hooks";

import updateAreaCoverageMutation from "../graph-ql/updateAreaCoverage.graphql";

const useMutationUpdateAreaCoverage = ({
  onCompleted,
}: {
  onCompleted: () => void;
}) =>
  useMutation(updateAreaCoverageMutation, {
    fetchPolicy: "no-cache",
    onCompleted,
  });

export default useMutationUpdateAreaCoverage;
